const ellipsis = (text: string, size: number) => {
  return text.length > size ? `${text.slice(0, size)}...` : text;
};

const formulateName = (text:string)=>{
  return text?.split(" ").map((name)=>{
    return `${name.substring(0,1).toUpperCase()}${name.substring(1)}`
  })?.join(" ");

}

export {ellipsis, formulateName};